$(function () {
	$('.js-services-item').click(function () {
		$(this).toggleClass('services__item-heading_active').next().slideToggle();
	});
})